const notFound = {
  title: "404",
  message: "Oops! Page not found",
  backHome: "Return to Home",
};

export default notFound;

